import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { AUTH_STATE_GUEST_COOKIE_NAME, RoutePathname } from '@as-react/common-types';
import { CookieUtil } from '@as-react/common-utils';
import { Banner, Box, Spinner } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { ShoplandingLogin } from '../../components/checkout/login/shoplanding/ShoplandingLogin';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useGuestLogin } from '../../hooks/useGuestLogin';
import { useOAuth } from '../../hooks/useOAuth';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { authActions } from '../../redux/authentication/actions/AuthActions.creators';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import checkoutActions from '../../redux/checkout/actions/CheckoutActions.creators';
import { generatePathUrl } from '../../util/URLParamUtil';
import { LoginLayout } from './CheckoutLoginContainer';
export const CheckoutLoginContainerNewAuth = () => {
    const { isShopLanding, root, isInAuthorMode } = useAemConfig();
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.general]);
    const { guestLogin, errorMessage: guestErrorMessage, isPending: isGuestLoginPending } = useGuestLogin();
    const { authUrl, isLoggedIn } = useOAuth({ returnTo: `${root}buy.html`, flow: 'checkout' });
    const guestError = t(guestErrorMessage || '');
    useEffect(() => {
        dispatch(basketActions.createGetAction());
        dispatch(authActions.createInitSocialAction());
        dispatch(analyticsActions.checkoutStep({ step: 2 }));
        dispatch(checkoutActions.createLoginAnalyticsAction());
        dispatch(checkoutActions.createSetHasRegistrationAction(false));
    }, []);
    useEffect(() => {
        if (isLoggedIn) {
            history.replace(generatePathUrl(root, `buy.html/${RoutePathname.DELIVERY}`, isInAuthorMode));
            return;
        }
        const guestCookie = CookieUtil.get(AUTH_STATE_GUEST_COOKIE_NAME);
        if (guestCookie) {
            guestLogin(guestCookie);
        }
        else {
            window.location.href = authUrl;
        }
    }, [isLoggedIn]);
    if (isShopLanding) {
        return (_jsx(LoginLayout, { children: _jsx(ShoplandingLogin, {}) }));
    }
    return (_jsxs(Box, { padding: "4", children: [guestError && _jsx(Banner, { text: guestError, status: "error" }), isGuestLoginPending && _jsx(Spinner, { fitContainer: true })] }));
};
